import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AdminPanel from './pages/AdminPanel';
import AnimalProfilePage from './pages/AnimalProfilePage';
import ImpressumPage from './pages/ImpressumPage';
import BuyerDashboard from './pages/BuyerDashboard';
import KittenPage from './pages/KittenPage';
import RatgeberPage from './pages/RatgeberPage';
import { getMe } from './api';
import { Toaster } from './components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      getMe()
        .then((res) => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('auth_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('auth_user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#EEF3F8]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#C5D0DA] border-t-[#7A9BB5] rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#7A9BB5] font-body">Laden...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<LandingPage user={user} onLogout={handleLogout} onLogin={handleLogin} />} />
        <Route path="/login" element={
          user?.role === 'admin'
            ? <Navigate to="/admin" replace />
            : <LoginPage onLogin={handleLogin} />
        } />
        <Route path="/admin/*" element={
          user?.role === 'admin'
            ? <AdminPanel user={user} onLogout={handleLogout} />
            : <Navigate to="/login" replace />
        } />
        <Route path="/dashboard/*" element={
          user
            ? <BuyerDashboard user={user} onLogout={handleLogout} />
            : <Navigate to="/login" replace />
        } />
        <Route path="/kitten" element={<KittenPage user={user} onLogout={handleLogout} />} />
        <Route path="/ratgeber" element={<RatgeberPage user={user} onLogout={handleLogout} />} />
        <Route path="/tier/:id" element={<AnimalProfilePage user={user} onLogout={handleLogout} />} />
        <Route path="/impressum" element={<ImpressumPage user={user} onLogout={handleLogout} />} />
        <Route path="/datenschutz" element={<ImpressumPage user={user} onLogout={handleLogout} page="datenschutz" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
